export const routesData = {
  APP_BASE_HREF: {
    path: '/abrir-cdt-avvillas/',
    redirectPath: '/abrir-cdt-avvillas'
  },
  HOME: {
    path: '',
    redirectPath: '/'
  },
  USER_IDENTIFICATION: {
    path: 'validacion-datos',
    redirectPath: '/validacion-datos'
  },
  PUBLICY_EXPOSED_PERSON: {
    path: 'pep',
    redirectPath: '/pep'
  },
  CDT_CONFIGURATION: {
    path: 'configuracion-cdt',
    redirectPath: '/configuracion-cdt'
  },
  CARD_MANAGEMENT_MEDIA: {
    path: 'medios-de-manejo',
    redirectPath: '/medios-de-manejo'
  },
  OTP: {
    path: 'autenticacion-otp',
    redirectPath: '/autenticacion-otp'
  },
  ECONOMIC_ACTIVITY: {
    path: 'actividad-economica',
    redirectPath: '/actividad-economica'
  },
  PERSONAL_INFORMATION: {
    path: 'informacion-personal',
    redirectPath: '/informacion-personal'
  },
  CONTACT_INFORMATION: {
    path: 'informacion-contacto',
    redirectPath: '/informacion-contacto'
  },
  FINANTIAL_INFORMATION: {
    path: 'informacion-financiera',
    redirectPath: '/informacion-financiera'
  },
  FOREIGN_CURRENCY_MOVEMENTS: {
    path: 'moneda-extranjera',
    redirectPath: '/moneda-extranjera'
  },
  ACCOUNT_SETTINGS: {
    path: 'configuracion-cuenta',
    redirectPath: '/configuracion-cuenta'
  },
  UPLOAD_DOCUMENTS_PRESIGNED: {
    path: 'cargue-documentos-prefirmados',
    redirectPath: '/cargue-documentos-prefirmados'
  },
  PRODUCT_SUMMARY: {
    path: 'resumen-producto',
    redirectPath: '/resumen-producto'
  },
  PRODUCT_SUMMARY_PSE: {
    path: 'resumen-producto-pse',
    redirectPath: '/resumen-producto-pse'
  },
  SAVING_TIPS: {
    path: 'tips-ahorro',
    redirectPath: '/tips-ahorro'
  },
  BIOMETRY: {
    path: 'biometria',
    redirectPath: '/biometria',
    INFO: {
      path: 'informacion/:tipo',
      redirectPath: '/biometria/informacion'
    },
    CONFIG: {
      path: 'configuracion',
      redirectPath: '/biometria/configuracion'
    },
    RESULT: {
      path: 'resultado/:tipo',
      redirectPath: '/biometria/resultado'
    },
    LAUNCHER: {
      path: 'capturador/:tipo',
      redirectPath: '/biometria/capturador'
    },
    UPLOAD: {
      path: 'cargue/:tipo',
      redirectPath: '/biometria/cargue'
    },
    VALIDATION: {
      path: 'validacion',
      redirectPath: '/biometria/validacion'
    }
  },
  ERRORS: {
    path: 'error',
    redirectPath: '/error',
    GENERAL_ERROR: {
      path: 'error-tecnico',
      redirectPath: '/error/error-tecnico'
    },
    USER_ERROR: {
      path: 'error-usuario',
      redirectPath: '/error/error-usuario'
    },
    NO_ACCOUNTS_ERROR: {
      path: 'error-cuentas',
      redirectPath: '/error/error-cuentas'
    },
    SUMMARY_ERROR: {
      path: 'error-resumen',
      redirectPath: '/error/error-resumen'
    },
    SUMMARY_PSE_ERROR: {
      path: 'error-pse-resumen',
      redirectPath: '/error/error-pse-resumen'
    },
    PSE_ERROR: {
      path: 'error-pse',
      redirectPath: '/error/error-pse'
    },
    PSE_PENDING_ERROR: {
      path: 'error-pending-pse',
      redirectPath: '/error/error-pending-pse'
    },
    OTP_ERROR: {
      path: 'error-otp',
      redirectPath: '/error/error-otp'
    },
    TIME_ERROR: {
      path: 'error-tiempo',
      redirectPath: '/error/error-tiempo'
    },
    NO_IDENTITY: {
      path: 'biometria-identidad',
      redirectPath: '/error/biometria-identidad'
    },
    TECH_FAILED: {
      path: 'biometria-tecnico',
      redirectPath: '/error/biometria-tecnico'
    },
    CAMERA: {
      path: 'biometria-camara',
      redirectPath: '/error/biometria-camara'
    }
  },
  NONDECLARATING_QUESTION: {
    path: 'persona-declarante',
    redirectPath: '/persona-declarante'
  },
  DIGITAL_SIGNATURE: {
    path: 'firma-documentos',
    redirectPath: '/firma-documentos'
  },
  CHANNEL_ENROLLMENT: {
    path: 'enrolamiento-cliente',
    redirectPath: '/enrolamiento-cliente'
  },
  PSE: {
    path: 'pse',
    redirectPath: '/pse'
  }
};
